var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4473 6.23223H14.7757V6.23105M2.75488 13.0962V9.76779M2.75488 9.76779L6.08331 9.76779M2.75488 9.76779L4.87548 11.8898C5.53583 12.5513 6.37387 13.0533 7.3417 13.3126C10.2758 14.0988 13.2916 12.3576 14.0778 9.42353M3.45261 6.57652C4.23879 3.64245 7.25465 1.90125 10.1887 2.68743C11.1566 2.94676 11.9946 3.44871 12.6549 4.1103L14.7757 6.23105M14.7757 2.90383V6.23105",
    stroke: "#26DDF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c3eac4d9e19df708a6490ccfb95227a1.svg";
export { ForwardRef as ReactComponent };